(function($, undefined) {
	
	'use strict';
	var formValidator;
	var form;
	
	var validatePasswords = function() {
		var currentPwInput = form.find('[name=currentPassword]');
		var newPwInput = form.find('[name=password]');
		var newPwConfirmInput = form.find('[name=passwordConfirm]');
		
		if (newPwInput.val().length > 0) {
			if (currentPwInput.val().length === 0) {
				currentPwInput.addClass('error').removeClass('success');	
			} else {
				currentPwInput.removeClass('error').addClass('success');	
			}
			if (newPwInput.val().length == 0 || newPwConfirmInput.val().length === 0) {
				if (newPwInput.val().length === 0) {
					newPwInput.addClass('error').removeClass('success');	
					
				} else {
					newPwInput.removeClass('error').addClass('success');
				}
				if (newPwConfirmInput.val().length === 0) {
					newPwConfirmInput.addClass('error').removeClass('success');
					
				} else {
					newPwConfirmInput.removeClass('error').addClass('success');
				}
			}
			else if (newPwInput.val() !== newPwConfirmInput.val()) {
				newPwInput.addClass('error').removeClass('success');
				newPwConfirmInput.addClass('error').removeClass('success');
			} 
			else {
				newPwInput.removeClass('error').addClass('success');
				newPwConfirmInput.removeClass('error').addClass('success');
			}
		} 
		else {
			// No password to update, so don't validate
			currentPwInput.removeClass('error').removeClass('success');
			newPwInput.removeClass('error').removeClass('success');
			newPwConfirmInput.removeClass('error').removeClass('success');
		}
		
		return !currentPwInput.hasClass('error') && !newPwInput.hasClass('error') && !newPwConfirmInput.hasClass('error');
	};
	
	var updatePerson = function() {
		var parent = form.closest('.admin-space-content');
		var action = this.form.action;
		var method = this.form.method;
		var errorMsg = $('.js-form-error-message', form);
		var successMsg = $('.js-form-success-message', form);
		var errorMsgPassword = $('.error-msg.password', form);
		
		var params = {
			ajax: true
		};
		successMsg.slideUp(300);
		errorMsg.slideUp(300);
		errorMsgPassword.slideUp(300);
		formValidator.validateForm(form);
		
		if(!form.hasClass('has-error') && validatePasswords()) {
			parent.addClass('processing');
			
			
			$('[name=username]', form).val($('[name=email]', form).val());
			var formData = form.serializeArray();
			var isUpdatingPassword = form.find('[name=password]').val().length > 0;
			for(var i = 0; i < formData.length;  i++) {
				if (formData[i].name.toLowerCase().indexOf('password') === -1 || (formData[i].name.toLowerCase().indexOf('password') !== -1 && isUpdatingPassword)) {
					params[formData[i].name] = formData[i].value;
				}
			}
			$.ajax({
				url: action,
				method: method,
				data: params,
				success: function(response) {
					console.log(response);
					parent.removeClass('processing');
					if (response.indexOf('success') !== -1) {
						successMsg.slideDown(300);
					} else {
						if (response.indexOf('wrong.password') !== -1) {
							form.find('[name=currentPassword]').addClass('error').removeClass('success');
							errorMsgPassword.slideDown(300);
						}
						errorMsg.slideDown(300);
					}
				},
				error: function(jqxhr, status, error) {
					parent.removeClass('processing');
					console.log(status + ' ' + error);
				}
			});
		}
	};
	
	var onOtherInputValueChange = function() {
		var input = $(this);
		var value = input.val();
		var ctn = input.closest('.select-with-other-option-ctn');
		var otherInputCtn = $('.other-input-value', ctn);
		var otherInput = $('.form-input', otherInputCtn);
		
		if (value == "autre") {
			otherInput.attr('value', "");
			otherInput.val("");
			otherInputCtn.slideDown(300);
		}
		else {
			otherInput.attr('value', value);
			otherInput.val(value);
			otherInputCtn.slideUp(300);
		}
	};
	
	var init = function () {
		formValidator = Fw.component.models().form;
		form = $('.edit-account-form');
		
		form.find('.form-submit-btn').on('click', updatePerson);
		
		$('.select-with-other-option-ctn .input-other-value-toggle-input').on('change', onOtherInputValueChange);
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
